import { Component, Host, Prop, h } from '@stencil/core';

/**
 * @slot - Designed to add custom content inside the badge.
 */
@Component({
  tag: 'sy-badge',
  styleUrl: 'scss/index.scss',
  shadow: true,
})
export class Badge {
  /**
   * Defines badge color/type, based on system color pallet pattern.
   */
  @Prop({ reflect: true }) color: 'primary' | 'secondary' | 'error' | 'warning' | 'success' | 'info' | 'default' =
    'default';

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
